import { render, staticRenderFns } from "./AnimalSelector.vue?vue&type=template&id=2c5fba37"
import script from "./AnimalSelector.vue?vue&type=script&lang=js"
export * from "./AnimalSelector.vue?vue&type=script&lang=js"
import style0 from "./AnimalSelector.vue?vue&type=style&index=0&id=2c5fba37&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports